/** Assp Devtools */

/**
 *  @description 设置DOM节点属性
 *  @param { Node } dom DOM对象
 *  @param { Object } attrMap 属性List
 */
var setDomAttribute = function(dom, attrMap) {
    if (!dom) {
        return;
    }
    for (var item in attrMap) {
        dom.setAttribute(item, attrMap[item]);
    }
    return dom;
}

/**
 *  @description 设置DOM节点样式
 *  @param { Node } dom DOM对象
 *  @param { Object } attrMap 样式List
 */
var setDomStyle = function(dom, attrMap) {
    if (!dom) {
        return;
    }
    for (var item in attrMap) {
        dom.style[item] = attrMap[item];
    }
    return dom;
}

module.exports = {
    setDomStyle: setDomStyle,
}